import React, { useEffect, useState } from "react";
import { Layout, Space } from "antd";
import { useRecoilState } from "recoil";
import Headers from "../frame/headers.component";
import LeftHeaders from "../frame/leftheaders.component";
import Footers from "../frame/footers.component";
import AuthService from "../../services/auth.service";
import { FilterValue, TablePaginationConfig } from "antd/es/table/interface";
import { MenuOutlined } from '@ant-design/icons';
import { UserTypeAtom, UserType } from "../../atom/user.atom";
import { API_BASE_URL } from "../../services/apiConfig";
import { API_BASE_URL_ISSUER } from "../../services/apiConfig";
import MemberListView from "../MemberListView";
import InvitationView from "../InvitationView";
import WaitListView from "../WaitListView";
import DuesListView from "../DuesListView";
import MemberList from "./message.component";
import ReceptionWaitListView from "../ReceptionWaitListView";
import NotificationView from "../NotificationView";
import FormlistView from "../FormlistView";
import ReservationListView from "../ReservationListView";
import FABRestaurant from "./FABRestaurant";
import FABCompnay from "./FABCompany";
import { MemberIdSave, ClubSeqSave } from '../../atom/user.atom';

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}
interface ClubInfo {
  club_seq: number;
  club_name: string;
  valid: boolean;
  club_category_seq: number;
  agentSeq: number;
}

export default function Home() {
  const [selectedClubInfo, setSelectedClubInfo] = useState<ClubInfo | null>(null);
  const [isclubselect, setisclubselect] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState("");
  const [width, setWidth] = useState(window.innerWidth);
  const [SelectClub, setSelectClub] = useState<string | null>(null);
  const [SelectValue, setSelectValue] = useState<string | null>(null);
  const [clubdataAll, setClubDataAll] = useState<string | null>(null);
  const [clubdata, setClubData] = useState<any | null>(null);
  const [profiledataAll, setProfileDataAll] = useState<string | null>(null);
  const [profiledata, setProfileData] = useState<string[]>([]);
  const [selectmemberidsoket, setselectmemberidsoket] = useState<string>("");
  const [issuermemberid, setissuermemberid] = useState<string>("");
  const [tokendata, settokendata] = useState<string | null>(null);
  const [selectedValue, setSelectedValue] = useState<number>(0);
  const [selectedDeviceName, setselectedDeviceName] = useState<string>("");
  const [selectedDeviceName1, setselectedDeviceName1] = useState<string>("");
  const [selectedDeviceall, setselectedDeviceall] = useState<any>("");
  const [SelectHeaderValue, setSelectHeaderValue] = useState<string | null>(null);
  const [userAtom, setUserAtom] = useRecoilState<UserType>(UserTypeAtom);
  const [selectedchangeroom, setselectedchangeroom] = useState<boolean>(false);
  const [token, settoken] = useState<string | null>(null);
  const [membercount, setmembercount] = useState<number>(0);
  const [extractedInfo, setextractedInfo] = useState<string[]>([]);
  const [ismenu, setismenu] = useState<boolean>(false);
  const [clubSeqSave, setClubSeqSave] = useRecoilState(ClubSeqSave);
  const [memberIdSave, setmemberIdSave] = useRecoilState(MemberIdSave);
  
  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    settoken(rawToken);
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {

  }, [width]);
  const onselectedDeviceall = (selectedDeviceall: any) => {
    // console.log("home 진료과ALl : " + selectedDeviceall);
    setselectedDeviceall(selectedDeviceall)
  };


  const clubimg = async () => {
    // console.log("클럽리스트  : " + JSON.stringify(clubdata, null, 2));

    const fetchClubDetails = async (club_seq: any) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/club/list/one/${club_seq}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        // console.log(`data for club_seq ${club_seq}: ${JSON.stringify(data, null, 2)}`);
        return { ...data, club_seq };
      } catch (error) {
        console.error(`Error fetching data for club_seq ${club_seq}:`, error);
        return null;
      }
    };

    const promises = clubdata.map((club: any) => fetchClubDetails(club.club_seq));
    const results = await Promise.all(promises);

    const updatedClubData = clubdata.filter((club: any) => club.valid == 1).map((club: any) => {
      const fetchedData = results.find(data => data && data.club_seq === club.club_seq);
      return fetchedData ? { ...club, imagePathCard: fetchedData.imagePathCard } : club;
    });

  };


  const fetchClubDetails = async (clubSeq: any) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/club/list/one/${clubSeq}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      // console.log("확인" + JSON.stringify(data.data, null, 2))
      // console.log(data.data)
      return data.data; // 클럽의 상세 정보 반환
    } catch (error) {
      console.error("클럽 상세 정보를 가져오는 중 오류 발생:", error);
      return null;
    }
  };

  // 각 클럽의 상세 정보를 가져와서 imagePathCard를 추가하는 함수
  const addImagePathCardToClubs = async (extractedInfo: any) => {
    try {
      const updatedClubs = [];
      for (const club of extractedInfo) {
        const clubDetails = await fetchClubDetails(club.club_seq);
        if (clubDetails) {
          // imagePathCard를 club 객체에 추가
          club.imagePathCard = clubDetails.imagePathCard;
          updatedClubs.push(club);
        }
      }
      // console.log("업데이트된 클럽 데이터:", updatedClubs);
      return updatedClubs;
    } catch (error) {
      console.error("클럽 데이터에 imagePathCard를 추가하는 중 오류 발생:", error);
      return null;
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      // console.log("실행")
      const updatedClubs = await addImagePathCardToClubs(extractedInfo);
      // console.log("실행@" + JSON.stringify(updatedClubs, null, 2))
      setClubData(updatedClubs)
      // Use updatedClubs here or set it to state if necessary
    };

    fetchData(); // Call the async function here
  }, [extractedInfo]);
  useEffect(() => {
    const interval = setInterval(async () => {
      const token1 = AuthService.getCurrentToken();

      const issue = token1.issue;
      const year = issue.slice(0, 4);
      const month = issue.slice(4, 6);
      const day = issue.slice(6, 8);
      const hours = issue.slice(8, 10);
      const minutes = issue.slice(10, 12);
      const seconds = issue.slice(12, 14);
      const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      const currentTime = new Date();
      const formattedDateTime = new Date(formattedTime);
      if (formattedDateTime < currentTime) {
        console.log("만료됨");
        setUserAtom({
          showModeratorBoard: false,
          showAdminBoard: false,
          currentUser: undefined,
        });

        AuthService.logout();
        window.location.href = "/login";
      } else {
        // console.log("토큰 유효함");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [token]);

  useEffect(() => {
    if (token !== null) {
      // console.log("(ExcelUpload) 선택한 클럽정보 :" + JSON.stringify(selectedClubInfo, null, 2))
      // console.log("선택 클럽 시퀀스 : " + selectedClubInfo?.club_seq)
      if (selectedClubInfo?.club_seq === 0 || selectedClubInfo?.club_seq === null) {
        setisclubselect(false)
        setSelectHeaderValue("")
      } else {
        setisclubselect(true)
        if (selectedClubInfo?.agentSeq === 1) {
          setSelectHeaderValue("waitlist")
        } else if (selectedClubInfo?.agentSeq === 3) {
          setSelectHeaderValue("reception")
        } else {
          setSelectHeaderValue("memberlist")
        }
        setClubSeqSave(selectedClubInfo)
        localStorage.setItem('ClubSeqSave', selectedClubInfo?.club_seq+"");
        localStorage.setItem('TokenSave', token+"");
        
      }


    }




  }, [selectedClubInfo]);
  useEffect(() => {
    if (token !== null) {
      setSelectHeaderValue(SelectValue);
    }
  }, [SelectValue]);


  useEffect(() => { //내가 생성한 클럽 조회
    if (token !== null) {
      fetch(
        `${API_BASE_URL}/club/list/my/issuer?page=0&size=70000&sort=clubSeq,desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.data && data.data.content) {
            // console.log("토큰 : " + token)
            console.log("내가생성한 클럽 로우 : " + JSON.stringify(data.data.content, null, 2));
            setClubDataAll(data.data.content)

            const extractedInfo = data.data.content
              // .filter((club: any) => club.valid == 1) // valid 값이 1인 경우만 필터링
              .filter((club: any) => club.deleted == 0)
              .map((club: any) => ({
                club_seq: club.clubSeq,
                club_name: club.clubName,
                valid: club.valid,
                club_category_seq: club.clubCategory.categoryCode,
                agentSeq: club.agentSeq === 0 ? 2 : club.agentSeq,
                club_deleted: club.deleted
              }));
            setextractedInfo(extractedInfo)
            console.log("클럽데이터 : " + JSON.stringify(extractedInfo, null, 2));

            setClubData(extractedInfo)
          }
        });
    }
  }, [token]);


  useEffect(() => { //프로필 조회
    if (token !== null) {


      fetch(
        `${API_BASE_URL}/member/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log("(home) 프로필 데이터 로우 : " + JSON.stringify(data.data, null, 2));
          const dataArray = Array.isArray(data.data) ? data.data : [data.data];
          setProfileDataAll(dataArray)
          const extractedInfo = dataArray.map((profiledata: any) => ({
            profileFilePath: profiledata.profileFilePath,
            memberDid: profiledata.memberDid,
            memberId: profiledata.memberId,
          }));

          setmemberIdSave(extractedInfo[0].memberId)

          localStorage.setItem('MemberIdSave', extractedInfo[0].memberId);


          // console.log("(home) 프로필데이터 : " + JSON.stringify(extractedInfo, null, 2))
          setProfileData(extractedInfo);
          setselectmemberidsoket(extractedInfo[0].memberId)
        })
        .catch(error => {
          console.error("프로필 조회 중 오류 발생:", error);
        });
    }
  }, [token]);





  const onSelectClick = (SelectValue: string) => {
    console.log("(home) 선택한 헤더 : " + SelectValue)
    setSelectValue(SelectValue);
  };
  useEffect(() => {
    const rawToken = AuthService.getRawToken(); // 디코딩하지 않은 토큰 가져오기
    settokendata(rawToken);
  }, []);

  useEffect(() => {
    // 사용자 로그인 유무 토큰 확인
    const user = AuthService.getCurrentToken();

    if (!user) {
      window.location.href = "/login";
      return;
    }
    const deviceId = user["device-id"][0];

    const userId = AuthService.getCurrentUserId();
    if (!!!userId?.trim()) {
      window.location.href = "/login";
      return;
    }
  }, []);
  const handleClubClick = (clubSeq: any) => {
    console.log(`(Home)클럽 ${clubSeq}이(가) 클릭되었습니다.`);
    if (clubSeq === SelectClub) {
      console.log("동일한클럽입니다.")
      setSelectClub(clubSeq + "#@#@");
    } else {
      setSelectClub(clubSeq);
    }



  };


  const onselectedDeviceNameChange = (selectedDeviceName: any) => {
    // console.log("(home) setselectedDeviceName : " + selectedDeviceName)
    setselectedDeviceName(selectedDeviceName)

  };
  const onselectchangeupdate = (selectchangeroom: any) => {
    if (selectedchangeroom === true) {
      setselectedchangeroom(false)
    } else {
      setselectedchangeroom(true)
    }

    // console.log("(home)selectchangeroom : " + selectchangeroom)
  };

  return (
    // <Layout style={{ backgroundColor: "#fff", height: "100vh", width: "100%" }}>

    //   <div
    //     style={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%" }}
    //   >
    //     {width > 1600 ? (
    //       <div style={{ flex: 0, height: "100px", width: "100%" }}>
    //         <Headers
    //           clubdata={clubdata}
    //           profiledata={profiledata}
    //           selectedValue={selectedValue}
    //           selectclub={SelectClub}
    //           selectedDeviceName={selectedDeviceName}
    //           selectedDeviceName1={selectedDeviceName1}
    //           selectedchangeroom={selectedchangeroom}
    //           selectmemberidsoket={selectmemberidsoket}
    //           selectedDeviceall={selectedDeviceall}
    //           onSelectClick={onSelectClick}
    //           onClubInfoSelect={setSelectedClubInfo}
    //           onselectedchangeroom={setselectedchangeroom}

    //         />
    //       </div>
    //     ) : (
    //       <div style={{ width: '100%', height: '50px', display: 'flex', alignItems: 'center' }}>
    //         <MenuOutlined
    //           style={{
    //             fontSize: '30px', // 아이콘 크기 설정
    //             margin: '30px', // 왼쪽 여백 추가
    //             cursor: "pointer"
    //           }}
    //           onClick={() => setismenu(!ismenu)}
    //         />
    //       </div>
    //     )}


    //     <div style={{ width: "100%", height: "1200px", display: "flex", overflowX: "auto", overflow: "hidden" }}>
    //       {ismenu && (
    //         <div style={{ width: "500px", backgroundColor: "#123758" }}>
    //           <Headers
    //             clubdata={clubdata}
    //             profiledata={profiledata}
    //             selectedValue={selectedValue}
    //             selectclub={SelectClub}
    //             selectedDeviceName={selectedDeviceName}
    //             selectedDeviceName1={selectedDeviceName1}
    //             selectedchangeroom={selectedchangeroom}
    //             selectmemberidsoket={selectmemberidsoket}
    //             selectedDeviceall={selectedDeviceall}
    //             onSelectClick={onSelectClick}
    //             onClubInfoSelect={setSelectedClubInfo}
    //             onselectedchangeroom={setselectedchangeroom}

    //           />
    //         </div>
    //       )}
    //       <div style={{ width: "100%", height: "100vh", padding: "0px" }}>
    //         {isclubselect === false && (
    //           // 첫페이지
    //           <div
    //             style={{
    //               width: "100%",
    //               height: "100vh",
    //               overflowY: "auto",
    //               display: "flex",
    //               flexWrap: "wrap", // 요소들이 여러 줄에 걸쳐 표시되도록 함
    //               justifyContent: "flex-start", // 요소들을 수평 왼쪽 정렬
    //               alignItems: "flex-start", // 요소들을 수직 상단 정렬
    //               // gap: "30px", // 카드 간의 간격을 줄이기 위해 gap 추가
    //             }}
    //           >
    //             {clubdata && clubdata.map((club: any) => (
    //               <div
    //                 key={club.club_seq}
    //                 style={{
    //                   width: "300px",
    //                   height: "150px",
    //                   margin: "30px",
    //                   color: "white",
    //                   borderRadius: "30px",
    //                   backgroundColor: club.club_category_seq === "1" || club.club_category_seq === "3" ? "#06B0D7" : "#6472EC",
    //                   backgroundImage: club.imagePathCard ? `url(${club.imagePathCard})` : (club.club_category_seq === "1" || club.club_category_seq === "3" ? `url('asset/img/blue_card_pattern.png')` : `url('asset/img/purple_card_pattern.png')`),
    //                   backgroundSize: club.imagePathCard ? "cover" : "55%", // Ensure the image covers the entire container
    //                   backgroundRepeat: "no-repeat",
    //                   backgroundPosition: club.imagePathCard ? "center" : "120px -60px",
    //                   textAlign: "center",
    //                   display: "flex",
    //                   alignItems: "center",
    //                   justifyContent: "center",
    //                   cursor: "pointer",
    //                 }}
    //                 onClick={() => handleClubClick(club.club_seq)}
    //               >
    //                 <h3>{club.club_name}</h3>
    //               </div>
    //             ))}
    //           </div>
    //         )}
    //         {SelectHeaderValue === "memberlist" && (
    //           <MemberListView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
    //             selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}
    //           ></MemberListView>
    //         )}
    //         {SelectHeaderValue === "invitation" && (
    //           <InvitationView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
    //             selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}
    //           ></InvitationView>
    //         )}
    //         {SelectHeaderValue === "reception" && (
    //           <WaitListView selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
    //             selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></WaitListView>
    //         )}
    //         {SelectHeaderValue === "waitlist" && (
    //           <ReceptionWaitListView onselectedDeviceall={onselectedDeviceall} SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
    //             selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></ReceptionWaitListView>
    //         )}
    //         {SelectHeaderValue === "dueslist" && (
    //           <DuesListView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
    //             selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></DuesListView>
    //         )}
    //         {SelectHeaderValue === "notification" && (
    //           <NotificationView selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
    //             selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></NotificationView>
    //         )}
    //         {SelectHeaderValue === "message" && (
    //           <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "20px" }}>
    //             <div style={{ fontSize: "24px" }}>
    //               | { } 메세지
    //             </div>
    //             <div
    //               style={{
    //                 width: "100%",
    //                 height: width <= 1600 ? "500px" : "1000px", overflowY: "auto"

    //               }}
    //             >
    //               <MemberList
    //                 clubSeq={selectedClubInfo?.club_seq ?? 0}
    //                 agentSeq={1}
    //                 memberid={selectmemberidsoket}
    //               // agentSeq={selectclubagentseq ?? 0} 
    //               />

    //             </div>
    //           </div>
    //         )}

    //       </div>
    //     </div>
    //   </div>
    // </Layout>
    <Layout style={{ backgroundColor: "#fff", height: "100vh", width: "100%" }}>

      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%" }}
      >

        <div style={{ flex: 0, height: "100px", width: "100%" }}>
          <Headers
            clubdata={clubdata}
            profiledata={profiledata}
            selectedValue={selectedValue}
            selectclub={SelectClub}
            selectedDeviceName={selectedDeviceName}
            selectedDeviceName1={selectedDeviceName1}
            selectedchangeroom={selectedchangeroom}
            selectmemberidsoket={selectmemberidsoket}
            selectedDeviceall={selectedDeviceall}
            onSelectClick={onSelectClick}
            onClubInfoSelect={setSelectedClubInfo}
            onselectedchangeroom={setselectedchangeroom}

          />
        </div>


        <div style={{ width: "100%", height: "1200px", display: "flex", overflowX: "auto", overflow: "hidden", padding: "30px" }}>

          <div style={{ width: "100%", height: "100vh", padding: "0px" }}>
            {isclubselect === false && (
              // 첫페이지
              <div
                style={{
                  width: "100%",
                  overflowY: "auto",
                  display: "flex",
                  flexWrap: "wrap", // 요소들이 여러 줄에 걸쳐 표시되도록 함
                  justifyContent: "flex-start", // 요소들을 수평 왼쪽 정렬
                  alignItems: "flex-start", // 요소들을 수직 상단 정렬
                  gap: "0px", // 카드 간의 간격을 줄이기 위해 gap 추가
                }}
              >
                {clubdata && clubdata.map((club: any) => (
                  <div
                    key={club.club_seq}
                    style={{
                      width: "300px",
                      height: "150px",
                      margin: "30px",
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: club.club_category_seq === "1" || club.club_category_seq === "3"
                        ? "#06B0D7"
                        : club.club_category_seq === "4"
                          ? "#E8A0E0"
                          : "#6472EC",
                      backgroundImage: club.imagePathCard
                        ? `url(${club.imagePathCard})`
                        : club.club_category_seq === "1" || club.club_category_seq === "3"
                          ? `url('asset/img/blue_card_pattern.png')`
                          : club.club_category_seq === "4"
                            ? `url('asset/img/pink_card_pattern.png')`  //변경필요
                            : `url('asset/img/purple_card_pattern.png')`,
                      backgroundSize: club.imagePathCard ? "cover" : "55%", // Ensure the image covers the entire container
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: club.imagePathCard ? "center" : "120px -60px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleClubClick(club.club_seq)}
                  >
                    <h3>{club.club_name}</h3>
                  </div>
                ))}
              </div>
            )}
            {SelectHeaderValue === "formlist" && (
              <FormlistView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></FormlistView>
            )}
            {SelectHeaderValue === "reservationlist" && (
              <ReservationListView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></ReservationListView>
            )}
            {SelectHeaderValue === "memberlist" && (
              <MemberListView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}
              ></MemberListView>
            )}
            {SelectHeaderValue === "invitation" && (
              <InvitationView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}
              ></InvitationView>
            )}
            {SelectHeaderValue === "reception" && (
              <WaitListView selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></WaitListView>
            )}
            {SelectHeaderValue === "waitlist" && (
              <ReceptionWaitListView onselectedDeviceall={onselectedDeviceall} SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></ReceptionWaitListView>
            )}
            {SelectHeaderValue === "dueslist" && (
              <DuesListView SelectValue={SelectValue || ""} selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></DuesListView>
            )}
            {SelectHeaderValue === "notification" && (
              <NotificationView selectedClubInfo={selectedClubInfo} onselectchangeupdate={onselectchangeupdate}
                selectmemberidsoket={selectmemberidsoket} onselectedDeviceNameChange={onselectedDeviceNameChange} profiledata={profiledata}></NotificationView>
            )}
            {SelectHeaderValue === "FABCompany" && (
              <FABCompnay></FABCompnay>


            )}
            {SelectHeaderValue === "FABRestaurant" && (
              <FABRestaurant selectedClubInfo={selectedClubInfo} profiledata={profiledata}></FABRestaurant>


            )}


            {SelectHeaderValue === "message" && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "20px", }}>
                <div style={{ fontSize: "24px" }}>
                  | { } 메세지
                </div>
                <div
                  style={{
                    width: "100%", overflowY: "auto", height: "100vh",

                  }}
                >
                  <MemberList
                    clubSeq={selectedClubInfo?.club_seq ?? 0}
                    agentSeq={1}
                    memberid={selectmemberidsoket}
                  // agentSeq={selectclubagentseq ?? 0} 
                  />

                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </Layout>
  );
}
